const { ItemReplacementSelector } = require('./General/ItemReplacementSelector');

module.exports = {
    Product: {
        ProductListing: require('./Product/ProductListing').default,
        ProductListingGrid: require('./Product/ProductListingGrid').default,
        InStockContainer: require('./Product/InStock').InStockContainer,
        AddToCart: require('./Product/ProductAddToCart').ProductAddToCart,
        Search: require('./General/SearchResults').SearchResults,
        Carousel: require('./Product/ProductCarousel').ProductCarousel,
        ApprovedStockListLogo: require('./Product/ProductApprovedStockListLogo').ProductApprovedStockListLogo,
        Alternatives: require('./Product/ProductAlternatives').ProductAlternatives,
        RelatedItemTab: require('./Product/ProductRelatedItemTab').ProductRelatedItemTab
    },
    Cart: {
        Summary: require('./Cart/CartSummary').CartSummary,
        Checkout: require('./Cart/CartCheckout').CartCheckout,
        Details: require('./Cart/CartDetails').CartDetails,
        CreateButton: require('./Cart/CartCreateButton').CartCreateButton,
        CartOrderApproval: require('./Cart/CartOrderApproval').CartOrderApproval,
        Reorder: require('./Cart/CartReorder').CartReorder
    },
    Order: {
        Pod: require('./Order/OrderPod').OrderPod,
        Listing: require('./Order/OrderListing').OrderListing,
        Summary: require('./Order/OrderSummary').OrderSummary
    },
    Group: {
        Listing: require('./Group/GroupListing').GroupListing,
        Edit: require('./Group/GroupEdit').GroupEdit
    },
    Site: {
        Listing: require('./Site/SiteListing').SiteListing,
        Edit: require('./Site/SiteEdit').SiteEdit,
        View: require('./Site/SiteView').SiteView,
        EditAndView: require('./Site/SiteEditAndView').SiteEditAndView
    },
    Report: {
        Selector: require('./Report/ReportSelector').ReportSelector,
        Listing: require('./Report/ReportScheduleListing').ReportScheduleListing
    },
    Template: {
        Listing: require('./Template/TemplateListing').TemplateListing,
        Edit: require('./Template/TemplateEdit').TemplateEdit,
        View: require('./Template/TemplateView').TemplateView,
        EditAndView: require('./Template/TemplateEditAndView').TemplateEditAndView,
        Modify: require('./Template/TemplateModify').TemplateModify
    },
    Invoice: {
        Listing: require('./General/InvoiceListing').InvoiceListing
    },
    ApprovedStocklist: {
        Listing: require('./ApprovedStocklist/ApprovedStocklistListing').ApprovedStocklistListing,
        Edit: require('./ApprovedStocklist/ApprovedStocklistEdit').ApprovedStocklistEdit
    },
    Account: {
        CompanySwitcher: require('./User/AccountCompanySwitcher').AccountCompanySwitcher,
        UserLogin: require('./User/UserLogin').UserLogin,
        LoginModal: require('./User/LoginModal').LoginModal
    },
    Equipment: {
        Listing: require('./Equipment/EquipmentListing').EquipmentListing,
        EditAndView: require('./Equipment/EquipmentEditAndView').EquipmentEditAndView,
        View: require('./Equipment/EquipmentView').EquipmentView,
        Edit: require('./Equipment/EquipmentEdit').EquipmentEdit
    },

    Service: {
        Listing: require('./Service/ServiceListing').ServiceListing,
        EditAndView: require('./Service/ServiceEditAndView').ServiceEditAndView,
        View: require('./Service/ServiceView').ServiceView,
        Edit: require('./Service/ServiceEdit').ServiceEdit
    },

    Technician: {
        TripListing: require('./Technician/TechnicianTripListing').TechnicianTripListing
    },

    GeneralLedger: {
        Listing: require('./GeneralLedger/GeneralLedgerListing').GeneralLedgerListing,
        Edit: require('./GeneralLedger/GeneralLedgerEdit').GeneralLedgerEdit
    },

    User: {
        Listing: require('./User/UserListing').UserListing,
        Edit: require('./User/UserEdit').UserEdit
    },

    PasswordReset: require('./User/PasswordReset'),
    RegisterForm: require('./User/RegisterForm').RegisterForm,
    Profile: require('./User/ProfileEdit').ProfileEdit,
    Search: require('./General/Search').Search,
    Alert: require('./General/Alert').Alert,
    CategoryListing: require('./General/CategoryListing').CategoryListing,
    Date: require('./General/Date').Date,
    QuantitySelector: require('./General/QuantitySelector').Date,
    ItemReplacementSelector: require('./General/ItemReplacementSelector').ItemReplacementSelector
};

